import * as React from 'react';
import { cn } from '../../utils';

const DashedDivider = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    role="separator"
    className={cn('w-full', className)}
    style={{
      height: 2,
      backgroundImage:
        'repeating-linear-gradient(90deg, var(--border) 0px 8px, transparent 8px 16px)',
    }}
    {...props}
  />
));
DashedDivider.displayName = 'DashedDivider';

export { DashedDivider };
